import { GetManySamplesStatus } from "@/shared/types";
import { DateTime } from "luxon";

function getCashFormat(value: number): number {
  return parseFloat(value.toFixed(2));
}

export const getCreateDtoByFormData = (formData: any) => {
  const a = {
    accession: formData.accession,
    biobankId: formData.biobankId,
    biomarkerValue: formData.biomarkerValue,
    collectionDate: formData.collectionDate || null,
    donorAge: Number(formData.donorAge),
    donorEthnicity: formData.donorEthnicity,
    donorGender: formData.donorGender,
    donorZip: formData.donorZip,
    invoiceId: +formData.invoiceId,
    loincBiomarker: formData.loincBiomarker,
    loincCode: formData.loincBiomarker?.id,
    specimenPrice: getCashFormat(+formData.specimenPrice),
    status: formData.status ? formData.status : GetManySamplesStatus.AVAILABLE,
    storageCondition: formData.storageCondition,
    storageContainer: formData.storageContainer,
    storageFacilityId: +formData.storageFacilityId,
    storageLocation: formData.storageLocation,
    volumeNumber: +formData.volumeNumber,
    volumeUnits: formData.volumeUnits,
    freezerId: formData.freezerId,
    rackId: formData.rackId,
    spesimenAssay: formData.spesimenAssay,
    instrument: formData.instrument,
  };
  return a;
};

export const getUpdateDtoByFormData = (formData: any) => {
  const a = {
    accession: formData.accession,
    biobankId: formData.biobankId,
    biomarkerValue: formData.biomarkerValue,
    collectionDate: formData.collectionDate || null,
    donorAge: Number(formData.donorAge),
    donorEthnicity: formData.donorEthnicity,
    donorGender: formData.donorGender,
    donorZip: formData.donorZip,
    invoiceId: +formData.invoiceId,
    loincBiomarker: formData.loincBiomarker,
    loincCode: formData.loincBiomarker?.id,
    specimenPrice: getCashFormat(+formData.specimenPrice),
    status: formData.status,
    storageCondition: formData.storageCondition,
    storageContainer: formData.storageContainer,
    storageFacilityId: +formData.storageFacilityId,
    storageLocation: formData.storageLocation,
    volumeNumber: +formData.volumeNumber,
    volumeUnits: formData.volumeUnits,
    freezerId: formData.freezerId,
    rackId: formData.rackId,
    specimenAssay: formData.specimenAssay,
    instrument: formData.instrument,
  };
  return a;
};

export const parseDate = (
  isoString: string,
  timeZone = "UTC+2"
): string | null => {
  try {
    const utcDateTime = DateTime.fromISO(isoString, { zone: "utc" });
    const localDateTimeInMillis = utcDateTime.setZone(timeZone).toMillis();
    const ts = DateTime.fromMillis(localDateTimeInMillis);
    return ts.toFormat("MM/dd/yyyy");
  } catch (error) {
    console.error("Invalid date string or time zone:", error);
    return null;
  }
};

const formatDate = (formatDate: string): string | null => {
  const localDateTime = DateTime.fromFormat(formatDate, "MM/dd/yyyy");
  const utcDateTime = localDateTime.setZone("utc");

  return utcDateTime.toISO({ includeOffset: false }); // e.g., 2024-07-16T10:36:13.385Z
};
